import React from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import LinkScriptDashboard from './link-script-dashboard'
import LinkScriptSettings from './link-script-settings'

const LinkScriptPage: React.FC = () => {
    const location = useLocation()
    const navigate = useNavigate()

    const activeKey =
        location.pathname === '/link-script-settings'
            ? 'settings'
            : 'overview'

    const handleSelect = (key: string | null) => {
        if (key === 'overview') navigate('/link-script')
        if (key === 'settings') navigate('/link-script-settings')
    }

    return (
        <div >

            <Tabs activeKey={activeKey} onSelect={handleSelect} className="mb-3">
                <Tab eventKey="overview" title="Overview" />
                <Tab eventKey="settings" title="Settings" />
            </Tabs>

            {activeKey === 'overview' && <LinkScriptDashboard />}
            {activeKey === 'settings' && <LinkScriptSettings />}

        </div>
    )
}

export default LinkScriptPage
